import { useEffect, useState, React } from "react";
import HeaderDashboard from "../../components/HeaderDashboard"
// import { useUser } from "../../../contexts/UserContext";
import { Breadcrumbs, Link, Typography, Box, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Loading from "../../components/Loading";
import axios from "axios";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import Button from "@mui/material/Button";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import HowToVoteOutlinedIcon from "@mui/icons-material/HowToVoteOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AddIcon from '@mui/icons-material/Add';
import UploadBox from "./UploadBox";

const TEXT = "#333333";
const MUTED = "#828282";
const PURPLE = "#9C01B9";

function DocumentCard({
    icon,
    title,
    status,
    statusColor = "#DFF7EB",
    statusTextColor = "#16834B",
    fileName,
    size,
    description,
    onView,
}) {
    const hasDocument = Boolean(fileName);

    // Valores padrão quando o documento ainda não foi enviado
    const currentStatus = hasDocument
        ? (status || "Enviado")
        : "Não enviado";

    const currentStatusColor = hasDocument
        ? statusColor
        : "#FFF3CD";

    const currentStatusTextColor = hasDocument
        ? statusTextColor
        : "#856404";

    const currentFileName = hasDocument
        ? fileName
        : "Nenhum documento enviado";

    const currentSize = hasDocument
        ? size
        : "Aguardando envio";

    const currentDescription = hasDocument
        ? description
        : "Envie este documento para concluir o cadastro.";

    return (
        <Box
            sx={{
                flex: "1 1 0",
                minWidth: 200,
                bgcolor: "#F5F6F8",
                borderRadius: 2,
                p: 1.4,
                display: "flex",
                flexDirection: "column",
                gap: 1,
            }}
        >
            {/* Título + Status */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    minWidth: 0,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.7,
                        minWidth: 0,
                    }}
                >
                    {icon}

                    <Typography
                        sx={{
                            fontSize: 11.5,
                            fontWeight: 600,
                            color: "#303030",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {title}
                    </Typography>
                </Box>

                <Chip
                    label={currentStatus}
                    size="small"
                    sx={{
                        height: 18,
                        flexShrink: 0,
                        bgcolor: currentStatusColor,
                        color: currentStatusTextColor,
                        fontSize: 8.5,
                        fontWeight: 600,
                        "& .MuiChip-label": {
                            px: 0.8,
                        },
                    }}
                />
            </Box>

            {/* Arquivo */}
            <Box
                sx={{
                    bgcolor: "#FFF",
                    borderRadius: 1.5,
                    px: 1,
                    py: 0.8,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.8,
                    minWidth: 0,
                    border: !hasDocument
                        ? "1px dashed #D9DDE2"
                        : "1px solid transparent",
                }}
            >
                <DescriptionOutlinedIcon
                    sx={{
                        fontSize: 18,
                        color: hasDocument
                            ? "#68717A"
                            : "#9CA3AF",
                        flexShrink: 0,
                    }}
                />

                <Box
                    sx={{
                        minWidth: 0,
                        flex: 1,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 10,
                            color: hasDocument
                                ? "#303030"
                                : "#737980",
                            fontWeight: hasDocument
                                ? 400
                                : 500,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {currentFileName.split("\\").pop()}
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: 9,
                            color: MUTED,
                            mt: 0.2,
                        }}
                    >
                        {currentSize}
                    </Typography>
                </Box>

                {/* <Button
                    size="small"
                    disabled={!hasDocument}
                    onClick={onView}
                    sx={{
                        minWidth: 24,
                        width: 24,
                        height: 24,
                        p: 0,
                        color: "#65717A",
                        flexShrink: 0,

                        "&.Mui-disabled": {
                            color: "#C5C9CD",
                        },
                    }}
                >
                    <VisibilityOutlinedIcon
                        sx={{
                            fontSize: 16,
                        }}
                    />
                </Button> */}
            </Box>

            {/* Informação inferior */}
            <Typography
                sx={{
                    fontSize: 9,
                    color: hasDocument
                        ? MUTED
                        : "#8A6D1D",
                    lineHeight: 1.3,
                }}
            >
                {currentDescription}
            </Typography>
        </Box>
    );
}

const Documentos = () => {


    // const { user } = useUser();
    const [socios, setSocios] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [openDocumentos, setOpenDocumentos] = useState(false);
    const [socioSelecionado, setSocioSelecionado] = useState(null);

    const getSocios = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/get/socios-fichaCadastral`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem("token")
                }
            });
            setSocios(response.data.socios);
        } catch (error) {
            console.error("Erro ao buscar sócios:", error);
            return;
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getSocios();
    }, []);

    return (
        <>
            <HeaderDashboard />
            <div style={{ marginTop: "60px", padding: "20px", minHeight: "100vh", marginBottom: "50px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                    <div style={{ width: "80%" }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                color="inherit"
                                onClick={() => navigate("../dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography
                                sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                            >
                                <InsertDriveFileIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Documentos
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <Box
                    sx={{
                        width: window.innerWidth > 768 ? "80%" : "100%",
                        minHeight: "100vh",
                        // backgroundColor: BACKGROUND,
                        boxSizing: "border-box",
                        margin: "20px auto",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: {
                                xs: "flex-start",
                                sm: "center",
                            },
                            justifyContent: "space-between",
                            gap: 2,
                            mb: 3,
                            flexDirection: {
                                xs: "column",
                                sm: "row",
                            },
                        }}
                    >
                        <Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    flexWrap: "wrap",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: {
                                            xs: 21,
                                            sm: 23,
                                        },
                                        fontWeight: 700,
                                        color: TEXT,
                                        lineHeight: 1.2,
                                    }}
                                >
                                    Documentos dos sócios
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    mt: 0.5,
                                    color: MUTED,
                                    fontSize: 13,
                                }}
                            >
                                Gerencie e visualize os documentos dos sócios da empresa.
                            </Typography>
                        </Box>
                    </Box>
                    {socios.length === 0 ? (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                gap: 1.2,
                                py: 8,
                                px: 3,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 52,
                                    height: 52,
                                    borderRadius: "50%",
                                    bgcolor: "rgba(156, 1, 185, 0.08)",
                                    color: PURPLE,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mb: 0.5,
                                }}
                            >
                                <GroupOutlinedIcon sx={{ fontSize: 26 }} />
                            </Box>

                            <Typography
                                sx={{
                                    fontSize: 15,
                                    fontWeight: 600,
                                    color: "#222",
                                }}
                            >
                                Nenhum sócio cadastrado
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: 13,
                                    color: MUTED,
                                    maxWidth: 420,
                                    lineHeight: 1.5,
                                }}
                            >
                                Para enviar a documentação, é necessário cadastrar pelo menos um
                                sócio da empresa.
                            </Typography>

                            <Button
                                variant="contained"
                                onClick={() => navigate("../dashboard/fichaCadastral")}
                                sx={{
                                    mt: 1,
                                    px: 2.5,
                                    height: 40,
                                    borderRadius: 1.5,
                                    bgcolor: PURPLE,
                                    textTransform: "none",
                                    fontSize: 13,
                                    fontWeight: 600,
                                    boxShadow: "none",
                                    "&:hover": {
                                        bgcolor: "#82009A",
                                        boxShadow: "none",
                                    },
                                }}
                                startIcon={<PersonAddAltOutlinedIcon />}
                            >
                                Cadastrar sócio
                            </Button>
                        </Box>
                    ) : (
                        socios.length > 0 && socios.map((socio) => (
                            <Box
                                key={socio.idFichaCadastral ?? socio.id ?? socio.cpf}
                                sx={{
                                    width: "100%",
                                    bgcolor: "#FFF",
                                    border: "1px solid #E8E8E8",
                                    borderRadius: 2.5,
                                    mb: 2,
                                    p: {
                                        xs: 1.5,
                                        sm: 2,
                                    },
                                    boxSizing: "border-box",
                                }}
                            >
                                {/* =========================================
                CABEÇALHO DO SÓCIO
            ========================================= */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: {
                                            xs: "flex-start",
                                            sm: "center",
                                        },
                                        justifyContent: "space-between",
                                        gap: 2,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {/* Informações do sócio */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1.2,
                                            minWidth: 0,
                                            flex: 1,
                                        }}
                                    >
                                        {/* Avatar */}
                                        <Box
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                minWidth: 38,
                                                borderRadius: "11px",
                                                bgcolor: PURPLE,
                                                color: "#FFF",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: 12,
                                                fontWeight: 700,
                                            }}
                                        >
                                            {socio.nome.split(" ").map(n => n[0].toUpperCase()).join("")}
                                        </Box>

                                        {/* Dados */}
                                        <Box sx={{ minWidth: 0 }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.7,
                                                    flexWrap: "wrap",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: 14,
                                                        fontWeight: 700,
                                                        color: "#202020",
                                                    }}
                                                >
                                                    {socio.nome}
                                                </Typography>

                                                <Chip
                                                    label="Sócio"
                                                    size="small"
                                                    sx={{
                                                        height: 18,
                                                        bgcolor: "#E7F7F0",
                                                        color: "#16834B",
                                                        fontSize: 10,
                                                        fontWeight: 600,
                                                        "& .MuiChip-label": {
                                                            px: 0.8,
                                                        },
                                                    }}
                                                />
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                    gap: {
                                                        xs: 0.5,
                                                        sm: 1,
                                                    },
                                                    mt: 0.35,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: 12,
                                                        color: MUTED,
                                                    }}
                                                >
                                                    CPF: {socio.cpf}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        color: "#9CA3AF",
                                                        fontSize: 12,
                                                    }}
                                                >
                                                    •
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: 12,
                                                        color: MUTED,
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        maxWidth: {
                                                            xs: 180,
                                                            sm: "none",
                                                        },
                                                    }}
                                                >
                                                    {socio.email}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        color: "#9CA3AF",
                                                        fontSize: 12,
                                                    }}
                                                >
                                                    •
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        fontSize: 12,
                                                        color: MUTED,
                                                    }}
                                                >
                                                    Participação: {Number(socio.percentual).toFixed(0)}%
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Status + botão */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            width: {
                                                xs: "100%",
                                                sm: "auto",
                                            },
                                        }}
                                    >

                                        <Button
                                            variant="contained"
                                            startIcon={
                                                <AddIcon
                                                    sx={{ fontSize: "15px !important" }}
                                                />
                                            }
                                            sx={{
                                                height: 30,
                                                minWidth: "auto",
                                                px: 1.5,
                                                bgcolor: "#EEF0F2",
                                                color: "#30343A",
                                                boxShadow: "none",
                                                borderRadius: 1.5,
                                                textTransform: "none",
                                                fontSize: 10,
                                                fontWeight: 600,
                                                "&:hover": {
                                                    bgcolor: "#E3E5E7",
                                                    boxShadow: "none",
                                                },
                                            }}
                                            onClick={() => {
                                                setSocioSelecionado(socio);
                                                setOpenDocumentos(true);
                                            }}
                                        >
                                            Enviar documentos
                                        </Button>
                                    </Box>
                                </Box>

                                {/* =========================================
                DOCUMENTOS
            ========================================= */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 1.2,
                                        mt: 2,
                                        flexWrap: {
                                            xs: "wrap",
                                            md: "nowrap",
                                        },
                                    }}
                                >
                                    <DocumentCard
                                        icon={<BadgeOutlinedIcon />}
                                        title="RG / CNH Oficial"
                                        status={socio?.documentos?.rgCnhStatus || false}
                                        fileName={socio?.documentos?.rgCnhFileName || false}
                                        description="Documento de Identidade"
                                    />

                                    <DocumentCard
                                        icon={<HowToVoteOutlinedIcon />}
                                        title="Título de Eleitor"
                                        status={socio?.documentos?.tituloEleitorStatus || false}
                                        fileName={socio?.documentos?.tituloEleitorFileName || false}
                                        description="Título de Eleitor"
                                    />

                                    <DocumentCard
                                        icon={<HomeOutlinedIcon />}
                                        title="Comprovante Residência"
                                        status={socio?.documentos?.comprovanteResidenciaStatus || false}
                                        fileName={socio?.documentos?.comprovanteResidenciaFileName || false}
                                        description="Comprovante de Residência"
                                    />
                                </Box>
                            </Box>
                        ))
                    )}
                </Box>
            </div>
            <Loading open={loading} />
            <UploadBox
                open={openDocumentos}
                socio={socioSelecionado}
                onClose={() => setOpenDocumentos(false)}
                onSuccess={getSocios}
            />
        </>
    )
}

export default Documentos